var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenApp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 112,
    viewBox: "0 0 328 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_703_2876",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 328,
    height: 112
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.950012H321C324.9 0.950012 328 4.05001 328 7.95001V104.05C328 107.95 324.9 111.05 321 111.05H7C3.1 111.05 0 107.95 0 104.05V7.95001C0 4.05001 3.1 0.950012 7 0.950012Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_703_2876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.9 1.04999H-0.100098V111.15H327.9V1.04999Z",
    fill: "#C0F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7999 80.65H67.1999V62.35H56.3999V88.05H52.2999L46.9999 82.75V72.45H44.8999V46.05H39.7999V33.65H37.3999V40.55H32.1999V51.05H28.6999V85.25H25.4999V93.45H13.5999V72.15H10.8999V70.45H4.8999V72.15H-9.76548e-05L-0.100098 111.05L78.9999 111.15V87.05L69.7999 77.75V80.65Z",
    fill: "#8CE6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328 108.75V73.45C328 73.35 327.9 73.25 327.8 73.25H325.6C325.5 73.25 325.4 73.15 325.4 73.05V67.35C325.4 67.25 325.3 67.15 325.2 67.15H304.4C304.3 67.15 304.2 67.25 304.2 67.35V80.95C304.2 81.05 304.1 81.15 304 81.15H300.7C300.6 81.15 300.5 81.05 300.5 80.95V52.15C300.5 51.95 300.3 51.85 300.2 51.95L286.1 56.85C286 56.85 285.9 56.95 285.9 57.05V77.05C285.9 77.15 285.8 77.25 285.7 77.25H278.5C278.4 77.25 278.3 77.15 278.3 77.05V56.95C278.3 56.85 278.2 56.75 278.1 56.75H252.3C252.2 56.75 252.1 56.85 252.1 56.95V77.95C252.1 78.05 252 78.15 251.9 78.15H246.1C246 78.15 245.9 78.05 245.9 77.95V72.25C245.9 72.15 245.8 72.05 245.7 72.05H238.9C238.8 72.05 238.7 72.15 238.7 72.25V110.65C238.7 110.75 238.8 110.85 238.9 110.85H322.7C322.7 110.85 322.7 110.85 322.8 110.85C325.8 110.15 328 112.05 328 108.75Z",
    fill: "#8CE6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9999 111.15H133.9C115 98.65 92.2999 91.35 67.9999 91.35C44.1999 91.35 18.4999 99.15 -0.100098 111.05C0.899902 111.65 5.6999 111.15 6.9999 111.15Z",
    fill: "#5DCEE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.3 93.65C244.4 93.65 222 99.95 202.6 111.05H327.9C327.9 111.05 328 107.85 327.9 107.75C310.2 99.05 289.4 93.65 268.3 93.65Z",
    fill: "#5DCEE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 27.75H49.1998C51.4998 27.75 53.3998 25.85 53.3998 23.55C53.3998 21.25 51.4998 19.35 49.1998 19.35H17.9998C15.6998 19.35 13.7998 21.25 13.7998 23.55C13.7998 25.85 15.6998 27.75 17.9998 27.75Z",
    fill: "#8CE6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4998 20.75H44.1998C46.4998 20.75 48.3998 18.85 48.3998 16.55C48.3998 14.25 46.4998 12.35 44.1998 12.35H25.4998C23.1998 12.35 21.2998 14.25 21.2998 16.55C21.2998 18.85 23.1998 20.75 25.4998 20.75Z",
    fill: "#8CE6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 42.95H262.1C259.3 42.95 257 40.65 257 37.85C257 35.05 259.3 32.75 262.1 32.75H307C309.8 32.75 312.1 35.05 312.1 37.85C312.2 40.65 309.9 42.95 307 42.95Z",
    fill: "#8CE6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.9 34.45H271.1C268.3 34.45 266 32.15 266 29.35C266 26.55 268.3 24.25 271.1 24.25H291.9C294.7 24.25 297 26.55 297 29.35C297.1 32.05 294.8 34.45 291.9 34.45Z",
    fill: "#8CE6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.6 76.1499C118.6 76.1499 123.7 74.4499 131.7 75.0499C131.7 75.0499 130.3 80.3499 126.3 80.2499C122.2 80.1499 118.6 76.1499 118.6 76.1499Z",
    fill: "#2891B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.2 74.4499C120.2 74.4499 124.6 72.9499 130.5 73.6499C130.5 73.6499 128.9 76.5499 125.7 76.7499C122.6 76.9499 120.2 74.4499 120.2 74.4499Z",
    fill: "#F9DEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.1 63.25C136 66.45 138.2 71.75 135.8 80.55C133.3 89.65 131.5 99.25 131.6 104.55C131.8 110.75 131.6 115.75 134.3 116.55C138.2 117.65 145.6 107.45 147.5 102.45C149.3 94.15 152.7 90.95 153.6 84.45C156.2 67.65 151.2 57.05 141.1 63.25Z",
    fill: "#1FC8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.9 52.6499C165.9 49.8499 179.9 49.0499 182.5 52.2499C185.1 55.4499 175.8 68.3499 175.8 68.3499L162.5 58.9499L163.9 52.6499Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.9 68.75C165.9 65.85 165 62.05 165 62.05C165 62.05 165.4 55.35 165.5 49.25C165.5 48.75 165.5 48.25 165.5 47.75C165.5 45.05 165.5 42.65 165.4 41.15C164.9 35.95 181.1 45.05 181.1 45.05C181.1 45.05 181 47.45 181 50.55C181 54.65 181.3 59.85 182.1 62.55C183.7 67.15 175.9 71.55 170.9 68.75Z",
    fill: "#F4B298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 130.35C192 130.35 189.9 107.85 188.9 95.05C187.8 79.35 193.5 70.55 191.1 62.75L178 60.05L174.5 64.75L170.4 59.85L158.2 62.25C158.2 62.25 155.6 89.45 155.1 94.75C153.8 108.45 157.7 133.05 157.7 133.05",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.4 59.95L166.1 69.45C166.1 69.45 159.4 63.55 159.5 58.55L163.9 52.65L170.4 59.95Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 60.0499L183 68.4499C183 68.4499 187.5 64.7499 188.3 59.4499L182.4 52.2499L178 60.0499Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.5 151.75C203.5 151.75 200.5 116.15 200.4 106.05C200.3 96.0499 211 64.2499 205.4 58.7499C201.2 54.6499 195 59.0499 185.3 55.7499C185.3 55.7499 188.2 112.75 187.3 153.85",
    fill: "#1FC8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.4 149.75C144.4 149.75 149.2 121.05 148.7 108.75C148.1 96.4499 137.3 70.0499 138.6 66.4499C140.7 60.6499 153 60.2499 161.5 55.7499C161.5 55.7499 164.1 83.8499 163.8 103.15C163.5 122.45 161.2 153.05 161.2 153.05",
    fill: "#1FC8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.8 136.65L154.1 92.4499C154.1 92.3499 154.1 92.3499 154.1 92.2499L158.7 82.2499L151.3 74.9499C151.2 74.8499 151.2 74.7499 151.2 74.6499L155 58.6499C155 58.4499 155.2 58.3499 155.3 58.4499C155.5 58.4499 155.6 58.6499 155.5 58.7499L151.9 74.6499L159.3 82.0499C159.4 82.1499 159.4 82.2499 159.4 82.3499L154.8 92.4499L161.5 136.55",
    fill: "#2891B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 136.65L193 91.65L188.4 80.75C188.4 80.65 188.4 80.55 188.4 80.45L194.6 73.05L189.9 58.25C189.9 58.05 189.9 57.95 190.1 57.85C190.3 57.85 190.4 57.85 190.5 58.05L195.2 73.05C195.2 73.15 195.2 73.25 195.1 73.35L188.9 80.75L193.4 91.55V91.65L188.4 136.75",
    fill: "#2891B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.8 101.75C147.7 101.75 147.5 101.65 147.5 101.55L145 87.35C145 87.15 145.1 87.05 145.2 87.05C145.4 87.05 145.5 87.15 145.5 87.25L148 101.45C148.2 101.65 148 101.75 147.8 101.75C147.9 101.75 147.9 101.75 147.8 101.75Z",
    fill: "#2891B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.2 74.45C120.2 74.45 125.8 75.25 130.5 73.65L131.3 80.25C131.3 80.25 122.7 82.65 120.2 81.55V74.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 73.85C109.8 73.85 129.4 74.45 136.4 72.15C136.4 72.15 135.8 78.75 138 83.35C140.1 87.95 143.2 114.85 135.3 116.75C127.4 118.65 114.2 94.35 112.8 87.95C111.4 81.45 109.8 73.85 109.8 73.85Z",
    fill: "#1FC8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.6 98.05C136.5 98.05 136.4 97.85 136.4 97.65C137.9 90.95 137.5 78.05 137.5 77.95C137.5 77.75 137.6 77.55 137.7 77.55C137.8 77.55 137.9 77.65 138 77.85C138 78.35 138.4 91.05 136.9 97.85C136.9 97.95 136.7 98.15 136.6 98.05Z",
    fill: "#2891B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.6 94.15C139.5 94.15 139.4 94.05 139.4 93.85C139.4 89.05 137.7 83.95 137.7 83.95C137.7 83.85 137.7 83.65 137.8 83.55C137.9 83.45 138 83.55 138.1 83.65C138.1 83.75 139.8 88.85 139.9 93.75C139.8 93.95 139.7 94.15 139.6 94.15Z",
    fill: "#2891B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7 83.95C169.4 82.85 168.3 82.25 167.3 81.25C166.3 80.15 163.6 74.65 162.7 73.45C161.7 72.25 157.8 73.45 157.8 73.45C157.8 73.45 145.8 66.55 145.3 67.45C144.6 68.75 152.5 73.05 152.5 73.85C152.5 74.65 151.5 75.15 151.2 76.05C150.8 76.95 152 77.65 151 78.55C150 79.45 150.1 81.15 149.2 82.05C148.3 83.05 150.9 85.05 154.7 85.85C158.4 86.65 160.8 87.65 162.4 88.25C164 88.85 166.5 90.55 166.5 90.55L170.7 83.95Z",
    fill: "#FFBC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.4 75.75C161.4 75.75 161.3 75.75 161.4 75.75C160.5 75.55 158.4 74.1501 158.1 73.9501C158 73.8501 157.9 73.6501 158 73.5501C158.1 73.4501 158.3 73.3501 158.4 73.4501C159 73.8501 160.9 75.05 161.4 75.15C161.6 75.15 161.7 75.3501 161.6 75.4501C161.6 75.6501 161.5 75.75 161.4 75.75Z",
    fill: "#F4B298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.6 81.95C169.6 81.95 167 88.55 164.9 90.55C164.9 90.55 170.5 94.45 170.4 93.55C170.3 92.65 176.8 82.75 175 82.75C173.3 82.75 169.6 81.95 169.6 81.95Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.7 81.95C171.7 81.95 167 90.75 165.4 92.55C165.4 92.55 183.6 104.85 191.7 107.85C199.8 110.85 211 111.05 212.4 106.25C213.8 101.45 204.8 91.65 201.5 89.75C198.2 87.85 171.7 81.95 171.7 81.95Z",
    fill: "#1FC8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.4 58.65C209.5 65.15 209.3 77.85 211.5 83.75C212.9 87.45 216.2 102.25 211.9 107.05C207.5 111.75 195.8 104.05 195.5 95.25C195.3 86.35 201.8 52.85 205.4 58.65Z",
    fill: "#1FC8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5 86.65C195.4 86.65 195.2 86.55 195.2 86.35C195.2 86.25 195.3 86.05 195.4 86.05C195.8 85.65 196.6 81.65 197.1 78.95C197.3 77.75 197.5 76.55 197.7 75.75C197.7 75.55 197.9 75.45 198 75.55C198.2 75.55 198.3 75.75 198.2 75.85C198 76.75 197.8 77.85 197.6 79.05C196.6 84.75 196.2 86.55 195.5 86.65Z",
    fill: "#2891B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.6 83.55C196.5 83.55 196.3 83.45 196.3 83.35C196.3 83.15 195.6 79.65 195.9 76.85C195.9 76.65 196 76.55 196.2 76.55C196.4 76.55 196.5 76.75 196.5 76.85C196.3 79.55 196.9 83.15 196.9 83.25C196.9 83.35 196.8 83.45 196.6 83.55Z",
    fill: "#2891B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.7 68.75C199.5 68.75 199.4 68.55 199.4 68.35C200.2 65.35 203.2 58.55 203.3 58.25C203.4 58.15 203.5 58.05 203.7 58.15C203.8 58.25 203.9 58.35 203.8 58.55C203.8 58.65 200.6 65.55 199.9 68.55C200 68.65 199.9 68.75 199.7 68.75Z",
    fill: "#2891B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.4 74.45C143.3 74.45 143.1 74.35 143.1 74.15C142.5 69.45 140.5 65.05 140.5 64.95C140.4 64.85 140.5 64.65 140.6 64.55C140.7 64.45 140.9 64.55 141 64.65C141 64.65 143 69.25 143.7 73.95C143.7 74.25 143.6 74.45 143.4 74.45C143.5 74.45 143.4 74.45 143.4 74.45Z",
    fill: "#2891B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.5 93.85C206.4 93.85 206.3 93.85 206.3 93.75C201.3 88.05 186.6 85.75 186.4 85.65C186.2 85.65 186.1 85.45 186.2 85.35C186.2 85.15 186.4 85.05 186.5 85.15C187.1 85.25 201.6 87.55 206.7 93.35C206.8 93.45 206.8 93.65 206.7 93.75C206.7 93.85 206.6 93.85 206.5 93.85Z",
    fill: "#2891B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4 87.2499C193.3 87.2499 193.1 87.1499 193.1 87.0499C193.1 86.8499 193.2 86.7499 193.3 86.7499C193.4 86.7499 201 85.2499 206 85.2499C206.2 85.2499 206.3 85.3499 206.3 85.5499C206.3 85.7499 206.2 85.8499 206 85.8499C201.1 85.7499 193.6 87.2499 193.4 87.2499C193.5 87.2499 193.5 87.2499 193.4 87.2499Z",
    fill: "#2891B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.5 110.05C194.2 109.25 187.1 105.45 187 105.45C186.9 105.35 186.8 105.15 186.9 105.05C187 104.95 187.2 104.85 187.3 104.95C187.4 104.95 194.4 108.75 200.6 109.45C200.8 109.45 200.9 109.65 200.9 109.75C200.8 109.95 200.6 110.05 200.5 110.05Z",
    fill: "#2891B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.2 19.75C187.2 19.75 192 33.15 187.9 45.45C183.9 57.65 172.9 55.75 168.4 53.05C163.9 50.35 160.3 44.85 160.5 41.95C160.7 39.15 152.4 35.65 153.3 26.05C154.2 16.35 172.6 -0.0499783 187.2 19.75Z",
    fill: "#FFBC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.9 20.35C196.1 12.95 189.8 6.75004 175.6 4.35004C161.3 2.05004 158.9 12.75 158.9 12.75C158.9 12.75 152.1 12.35 151.8 25.15C151.5 38.15 161.9 47.35 161.9 47.35L164.1 34.45C165.1 32.65 164.6 15.75 172.9 18.65C181.2 21.55 187.3 20.15 187.3 20.15L188.5 24.15C188.5 24.15 191.3 24.15 192.9 20.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.9 37.55C165.4 40.95 162.2 43.25 158.6 42.75C155 42.25 152.5 39.15 153 35.75C153.5 32.35 156.7 30.05 160.3 30.55C163.8 31.05 166.3 34.15 165.9 37.55Z",
    fill: "#FFBC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.2 37.25C183.6 37.25 182.3 35.85 182.3 34.25L182.4 30.85C182.4 29.25 183.8 27.95 185.5 27.95C187.1 27.95 188.4 29.35 188.4 30.95L188.3 34.35C188.2 35.95 186.8 37.25 185.2 37.25Z",
    fill: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.4 32.75C187.2 34.05 186 34.95 184.7 34.75C183.4 34.55 182.5 33.35 182.7 32.05C182.9 30.75 184.1 29.85 185.4 30.05C186.7 30.25 187.6 31.45 187.4 32.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.7 31.35C184.7 31.65 184.3 31.95 184 31.85C183.7 31.85 183.4 31.45 183.5 31.15C183.5 30.85 183.9 30.55 184.2 30.65C184.5 30.65 184.8 31.05 184.7 31.35Z",
    fill: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.1 33.85C162.1 33.85 161 33.15 159.5 32.95C158.7 32.85 157.7 32.85 156.8 33.35C155.9 33.75 155.1 34.65 154.6 36.05C154.5 36.25 154.6 36.45 154.8 36.55C155 36.65 155.2 36.55 155.3 36.35C155.8 35.15 156.5 34.45 157.2 34.05C157.9 33.65 158.7 33.65 159.4 33.75C160 33.85 160.6 34.05 161 34.25C161.2 34.35 161.4 34.45 161.5 34.45C161.6 34.45 161.6 34.55 161.6 34.55C161.8 34.65 162 34.55 162.1 34.45C162.4 34.15 162.3 33.95 162.1 33.85Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.9 23.8501V23.6501V23.8501V23.6501V23.8501C185.9 23.8501 186 23.8501 186.2 23.8501C186.5 23.8501 187 23.8501 187.5 24.0501C187.7 24.1501 187.9 24.2501 188.1 24.4501C188.3 24.6501 188.4 24.8501 188.5 25.1501C188.6 25.5501 189.1 25.7501 189.5 25.6501C189.9 25.5501 190.1 25.0501 190 24.6501C189.8 24.1501 189.5 23.6501 189.2 23.3501C188.7 22.8501 188.1 22.5501 187.6 22.4501C187.1 22.3501 186.6 22.2501 186.2 22.2501C185.9 22.2501 185.7 22.2501 185.7 22.2501C185.3 22.3501 185 22.7501 185.1 23.1501C185.1 23.6501 185.5 23.9501 185.9 23.8501Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.4 23.4501L171.2 23.2501L171.4 23.4501L171.2 23.2501L171.4 23.4501C171.4 23.4501 171.7 23.1501 172.1 22.9501C172.3 22.8501 172.5 22.7501 172.8 22.6501C173 22.5501 173.3 22.5501 173.6 22.5501C173.8 22.5501 174.1 22.6501 174.4 22.8501C174.7 23.0501 175.2 22.9501 175.4 22.6501C175.6 22.3501 175.5 21.8501 175.2 21.6501C174.7 21.3501 174.2 21.1501 173.8 21.1501C173.3 21.0501 172.8 21.1501 172.4 21.2501C171.8 21.4501 171.3 21.7501 170.9 21.9501C170.6 22.2501 170.4 22.4501 170.3 22.4501C170 22.7501 170 23.2501 170.3 23.5501C170.6 23.7501 171.1 23.7501 171.4 23.4501Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.9 34.6501C179.9 34.6501 184.9 32.6501 189 35.7501C189 35.7501 187.6 38.4501 183.4 37.1501C179.3 35.8501 179.9 34.6501 179.9 34.6501Z",
    fill: "#FFBC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.8 35.65C172.1 35.65 170.7 34.15 170.7 32.45L170.8 28.85C170.8 27.15 172.3 25.75 174 25.85C175.7 25.95 177.1 27.35 177.1 29.05L177 32.65C177 34.25 175.5 35.65 173.8 35.65Z",
    fill: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.5 31.0501C176.3 32.4501 175 33.4501 173.6 33.2501C172.2 33.0501 171.2 31.7501 171.4 30.3501C171.6 28.9501 172.9 27.9501 174.3 28.1501C175.7 28.3501 176.7 29.6501 176.5 31.0501Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.8 29.65C173.7 30.05 173.4 30.25 173.1 30.25C172.7 30.15 172.5 29.85 172.5 29.55C172.6 29.15 172.9 28.95 173.3 28.95C173.6 28.95 173.9 29.25 173.8 29.65Z",
    fill: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.2 32.9501C168.2 32.9501 173.5 30.7501 177.8 34.0501C177.8 34.0501 176.3 36.9501 171.9 35.5501C167.6 34.1501 168.2 32.9501 168.2 32.9501Z",
    fill: "#FFBC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.2 34.65C180.2 34.65 183.7 34.45 183.3 36.95C182.9 39.45 179.9 38.25 179.9 38.25",
    fill: "#EE7988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.8 40.3501C175 40.9501 179 41.8501 182.4 42.1501C183.1 42.2501 183.4 43.0501 182.8 43.5501C181.3 44.8501 178.9 46.6501 176.8 46.4501C174.6 46.2501 172.8 43.3501 171.8 41.5501C171.6 40.8501 172.1 40.1501 172.8 40.3501Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.6 42.5501C181.6 42.5501 180.7 43.6501 180 43.6501C179.4 43.6501 173.6 42.5501 172.8 41.3501C172.3 40.6501 173.4 40.9501 173.4 40.9501C173.4 40.9501 176.7 42.3501 181.6 42.5501Z",
    fill: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.9 45.35C175.9 45.35 176.4 42.85 173.4 42.65C173.4 42.65 173.8 44.25 175.9 45.35Z",
    fill: "#EE7988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.6 74.05C138.6 74.05 139.5 80.75 135.2 86.35C130.9 92.05 128.8 94.35 121.1 94.25C113.4 94.15 107.7 90.55 105.4 84.65C103.1 78.85 138.6 74.05 138.6 74.05Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5997 62.75C92.9997 65.85 98.1997 73.45 100.7 73.95C103.3 74.35 108.4 59.15 107.1 55.35C105.8 51.65 93.1997 52.65 93.1997 54.95C93.1997 58.35 100.7 61.75 100.3 63.45C99.8997 65.15 94.0997 60.35 93.5997 62.75Z",
    fill: "#F4B298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.1 36.75C138.1 34.85 137.9 40.75 137.9 45.35C137.9 50.05 139.8 57.25 140 60.25C140.2 63.25 141.1 69.85 137.5 78.25C131.1 92.85 112.9 89.15 110.9 88.55C108 87.75 104.7 85.75 103 82.65C97.7997 73.05 103.3 62.35 102.1 57.25C99.0997 43.55 84.8997 23.85 90.1997 21.95C93.7997 20.65 101.9 37.85 109.3 39.55C121.2 42.25 134.1 36.75 134.1 36.75Z",
    fill: "#FFBC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4999 80.35H132.6C133.5 80.35 134.2 79.65 134.1 78.75V15.85C134.1 14.95 133.4 14.35 132.5 14.35H99.3999C98.4999 14.35 97.8999 15.05 97.8999 15.95V78.85C97.8999 79.65 98.5999 80.35 99.4999 80.35Z",
    fill: "#1E2C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.4 77.05H131.6C132.1 77.05 132.4 76.65 132.4 76.25V19.65C132.4 19.15 132 18.85 131.6 18.85H100.4C99.9001 18.85 99.6001 19.25 99.6001 19.65V76.25C99.6001 76.65 100 77.05 100.4 77.05Z",
    fill: "#00ACF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 17.25C119 17.55 119.2 17.75 119.5 17.75C119.8 17.75 120 17.55 120 17.25C120 16.95 119.8 16.75 119.5 16.75C119.2 16.75 119 16.95 119 17.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5 17.65H117.9C118.2 17.65 118.4 17.45 118.4 17.15C118.4 16.85 118.2 16.65 117.9 16.65H112.5C112.2 16.65 112 16.85 112 17.15C112 17.45 112.3 17.65 112.5 17.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.4 50.05C116.4 51.05 115.9 51.75 114.7 51.75C113.5 51.75 113.1 51.05 113.1 50.05V47.05H112.6V50.05C112.6 51.35 113.3 52.25 114.8 52.25C116.3 52.25 117 51.25 117 50.05V47.05H116.5L116.4 50.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.6 47.05H119.1V52.25H122.7V51.75H119.6V47.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.2 46.85C125.8 46.85 125.5 46.95 125.2 47.05C124.9 47.15 124.6 47.35 124.3 47.65C124.1 47.95 123.9 48.25 123.7 48.55C123.6 48.85 123.5 49.25 123.5 49.55C123.5 50.05 123.7 50.55 124 51.05C124.3 51.45 124.7 51.85 125.2 52.05C125.7 52.25 126.2 52.25 126.7 52.15C127.2 52.05 127.7 51.75 128.1 51.45C128.5 51.05 128.7 50.55 128.8 50.05C128.9 49.55 128.8 48.95 128.6 48.45C128.4 47.95 128.1 47.55 127.6 47.25C127.3 47.05 126.7 46.85 126.2 46.85ZM126.2 51.85C125.9 51.85 125.6 51.85 125.4 51.65C125.1 51.55 124.9 51.35 124.7 51.15C124.5 50.95 124.3 50.65 124.2 50.45C124.1 50.15 124.1 49.85 124.1 49.65C124.1 49.35 124.1 49.05 124.2 48.85C124.3 48.55 124.5 48.35 124.7 48.15C124.9 47.95 125.1 47.75 125.4 47.65C125.7 47.55 125.9 47.45 126.2 47.45C126.5 47.45 126.8 47.55 127 47.65C127.3 47.75 127.5 47.95 127.7 48.15C127.9 48.35 128.1 48.65 128.2 48.85C128.3 49.15 128.4 49.45 128.3 49.65C128.3 49.95 128.3 50.25 128.2 50.55C128.1 50.85 127.9 51.05 127.7 51.25C127.5 51.45 127.3 51.65 127 51.75C126.8 51.75 126.5 51.85 126.2 51.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.3 42.15H104.1V42.35H104.3V42.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.9 42.35H104.7V42.55H104.9V42.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.5 42.55H105.3V42.75H105.5V42.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2 42.85H106V43.05H106.2V42.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.8 43.05H106.6V43.25H106.8V43.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.4 43.25H107.2V43.45H107.4V43.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.999 43.55H107.899V43.75H108.099V43.55H107.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.599 43.75H108.399V43.95H108.599V43.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 43.95H108.899V44.05H109.099V43.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 42.75H104.8V42.95H105V42.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.5 42.95H105.3V43.05H105.5V42.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.099 43.15H105.899V43.35H106.099V43.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.599 43.35H106.399V43.55H106.599V43.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.2 43.55H107V43.75H107.2V43.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.8 43.75H107.6V43.95H107.8V43.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.3 43.95H108.1V44.05H108.3V43.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 44.05H108.6V44.25H108.8V44.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 44.25H109.1V44.45H109.3V44.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.599 43.25H105.399V43.45H105.599V43.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.099 43.45H105.899V43.65H106.099V43.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.599 43.65H106.399V43.85H106.599V43.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.099 43.75H106.899V43.95H107.099V43.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.599 43.95H107.399V44.15H107.599V43.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.099 44.15H107.899V44.35H108.099V44.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.599 44.25H108.399V44.45H108.599V44.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 44.45H108.899V44.65H109.099V44.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.5 44.55H109.3V44.75H109.5V44.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.099 43.85H105.899V44.05H106.099V43.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.5 43.95H106.3V44.15H106.5V43.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 44.05H106.8V44.25H107V44.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5 44.25H107.3V44.45H107.5V44.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.9 44.35H107.7V44.55H107.9V44.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4 44.55H108.2V44.75H108.4V44.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 44.65H108.6V44.85H108.8V44.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 44.75H109.1V44.95H109.3V44.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.7 44.85H109.5V45.05H109.7V44.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.599 44.35H106.399V44.55H106.599V44.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 44.45H106.8V44.65H107V44.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.4 44.55H107.2V44.75H107.4V44.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.8 44.65H107.6V44.85H107.8V44.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2 44.75H108V44.95H108.2V44.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7 44.85H108.5V45.05H108.7V44.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 44.95H108.899V45.15H109.099V44.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.5 45.05H109.3V45.25H109.5V45.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.9 45.25H109.7V45.45H109.9V45.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 44.75H106.8V44.95H107V44.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.4 44.85H107.2V45.05H107.4V44.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.7 44.95H107.5V45.15H107.7V44.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.099 45.05H107.899V45.25H108.099V45.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.5 45.15H108.3V45.35H108.5V45.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9 45.25H108.7V45.45H108.9V45.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 45.35H109.1V45.55H109.3V45.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 45.45H109.399V45.65H109.599V45.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.999 45.55H109.899V45.75H110.099V45.55H109.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.3 45.25H107.1V45.45H107.3V45.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.7 45.25H107.5V45.45H107.7V45.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.999 45.35H107.899V45.55H108.099V45.35H107.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4 45.45H108.2V45.65H108.4V45.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 45.55H108.6V45.75H108.8V45.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 45.55H108.899V45.75H109.099V45.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.5 45.65H109.3V45.85H109.5V45.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 45.75H109.6V45.95H109.8V45.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.099 45.75H109.899V45.95H110.099V45.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.599 45.65H107.399V45.85H107.599V45.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 45.65H107.8V45.85H108V45.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.3 45.75H108.1V45.95H108.3V45.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.599 45.75H108.399V45.95H108.599V45.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 45.85H108.8V46.05H109V45.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 45.95H109.1V46.05H109.3V45.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 45.95H109.399V46.15H109.599V45.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.9 46.05H109.7V46.25H109.9V46.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.3 46.05H110.1V46.25H110.3V46.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.9 45.95H107.7V46.15H107.9V45.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2 46.05H108V46.25H108.2V46.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.5 46.05H108.3V46.25H108.5V46.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 46.15H108.6V46.35H108.8V46.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 46.15H108.899V46.35H109.099V46.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4 46.25H109.2V46.45H109.4V46.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 46.25H109.6V46.45H109.8V46.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.099 46.35H109.899V46.55H110.099V46.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.4 46.35H110.2V46.55H110.4V46.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.099 46.35H107.899V46.55H108.099V46.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4 46.35H108.2V46.55H108.4V46.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7 46.35H108.5V46.55H108.7V46.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 46.45H108.8V46.65H109V46.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 46.45H109.1V46.65H109.3V46.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 46.55H109.399V46.75H109.599V46.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.9 46.55H109.7V46.75H109.9V46.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.099 46.55H109.899V46.75H110.099V46.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.4 46.65H110.2V46.85H110.4V46.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.3 46.65H108.1V46.85H108.3V46.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.599 46.65H108.399V46.85H108.599V46.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 46.75H108.6V46.95H108.8V46.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 46.75H108.899V46.95H109.099V46.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4 46.75H109.2V46.95H109.4V46.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.7 46.75H109.5V46.95H109.7V46.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 46.85H109.8V47.05H110V46.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2 46.85H110V47.05H110.2V46.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 46.85H110.3V47.05H110.5V46.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.5 46.95H108.3V47.15H108.5V46.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7 46.95H108.5V47.15H108.7V46.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 46.95H108.8V47.15H109V46.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.2 47.05H109V47.25H109.2V47.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.5 47.05H109.3V47.25H109.5V47.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 47.05H109.6V47.25H109.8V47.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.999 47.05H109.899V47.25H110.099V47.05H109.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.3 47.15H110.1V47.35H110.3V47.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.599 47.15H110.399V47.35H110.599V47.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.599 47.25H108.399V47.45H108.599V47.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 47.25H108.6V47.45H108.8V47.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 47.25H108.899V47.45H109.099V47.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 47.25H109.1V47.45H109.3V47.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 47.25H109.399V47.45H109.599V47.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 47.35H109.6V47.55H109.8V47.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.099 47.35H109.899V47.55H110.099V47.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.4 47.35H110.2V47.55H110.4V47.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.599 47.35H110.399V47.55H110.599V47.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7 47.45H108.5V47.65H108.7V47.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9 47.55H108.7V47.75H108.9V47.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 47.55H108.899V47.75H109.099V47.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4 47.55H109.2V47.75H109.4V47.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 47.55H109.399V47.75H109.599V47.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.9 47.55H109.7V47.75H109.9V47.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.099 47.55H109.899V47.75H110.099V47.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.4 47.55H110.2V47.75H110.4V47.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.599 47.55H110.399V47.75H110.599V47.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7 47.75H108.5V47.95H108.7V47.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 47.75H108.8V47.95H109V47.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.2 47.75H109V47.95H109.2V47.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4 47.75H109.2V47.95H109.4V47.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.7 47.85H109.5V48.05H109.7V47.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.9 47.85H109.7V48.05H109.9V47.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2 47.85H110V48.05H110.2V47.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.4 47.85H110.2V48.05H110.4V47.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7 47.85H110.5V48.05H110.7V47.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 48.05H108.6V48.25H108.8V48.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 48.05H108.8V48.25H109V48.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 48.05H109.1V48.25H109.3V48.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.5 48.05H109.3V48.25H109.5V48.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.7 48.05H109.5V48.25H109.7V48.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 48.05H109.8V48.25H110V48.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2 48.05H110V48.25H110.2V48.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.4 48.05H110.2V48.25H110.4V48.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7 48.05H110.5V48.25H110.7V48.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 48.25H108.6V48.45H108.8V48.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.999 48.25H108.899V48.45H109.099V48.25H108.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 48.25H109.1V48.45H109.3V48.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.5 48.25H109.3V48.45H109.5V48.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 48.25H109.6V48.45H109.8V48.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 48.25H109.8V48.45H110V48.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2 48.25H110V48.45H110.2V48.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.4 48.25H110.2V48.45H110.4V48.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7 48.25H110.5V48.45H110.7V48.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 48.45H108.6V48.65H108.8V48.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 48.45H108.899V48.65H109.099V48.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 48.55H109.1V48.75H109.3V48.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.5 48.55H109.3V48.75H109.5V48.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 48.55H109.6V48.75H109.8V48.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 48.55H109.8V48.75H110V48.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2 48.55H110V48.75H110.2V48.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.4 48.55H110.2V48.75H110.4V48.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7 48.55H110.5V48.75H110.7V48.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9 48.75H108.7V48.95H108.9V48.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 48.75H108.899V48.95H109.099V48.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 48.75H109.1V48.95H109.3V48.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 48.75H109.399V48.95H109.599V48.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 48.75H109.6V48.95H109.8V48.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.999 48.75H109.899V48.95H110.099V48.75H109.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2 48.75H110V48.95H110.2V48.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 48.75H110.3V48.95H110.5V48.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7 48.75H110.5V48.95H110.7V48.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9 48.95H108.7V49.15H108.9V48.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 48.95H108.899V49.15H109.099V48.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 48.95H109.1V49.15H109.3V48.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 48.95H109.399V49.15H109.599V48.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 48.95H109.6V49.15H109.8V48.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.999 48.95H109.899V49.15H110.099V48.95H109.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2 48.95H110V49.15H110.2V48.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 48.95H110.3V49.15H110.5V48.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7 48.95H110.5V49.15H110.7V48.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9 49.15H108.7V49.35H108.9V49.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 49.15H108.899V49.35H109.099V49.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 49.15H109.1V49.35H109.3V49.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 49.15H109.399V49.35H109.599V49.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 49.15H109.6V49.35H109.8V49.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.999 49.15H109.899V49.35H110.099V49.15H109.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2 49.15H110V49.35H110.2V49.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 49.15H110.3V49.35H110.5V49.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7 49.15H110.5V49.35H110.7V49.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9 49.35H108.7V49.55H108.9V49.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 49.35H108.899V49.55H109.099V49.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 49.35H109.1V49.55H109.3V49.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 49.35H109.399V49.55H109.599V49.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 49.35H109.6V49.55H109.8V49.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.999 49.35H109.899V49.55H110.099V49.35H109.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2 49.35H110V49.55H110.2V49.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 49.35H110.3V49.55H110.5V49.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7 49.35H110.5V49.55H110.7V49.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9 49.55H108.7V49.75H108.9V49.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 49.55H108.899V49.75H109.099V49.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 49.55H109.1V49.75H109.3V49.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 49.55H109.399V49.75H109.599V49.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 49.55H109.6V49.75H109.8V49.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.999 49.55H109.899V49.75H110.099V49.55H109.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2 49.55H110V49.75H110.2V49.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 49.55H110.3V49.75H110.5V49.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7 49.55H110.5V49.75H110.7V49.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.599 49.95V49.85L106.399 49.95H106.599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.9 49.95C106.9 49.85 106.9 49.85 106.9 49.75H106.8V49.85L106.9 49.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9 49.85H108.7V50.05H108.9V49.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 49.85H108.899V50.05H109.099V49.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 49.85H109.1V50.05H109.3V49.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 49.85H109.399V50.05H109.599V49.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 49.85H109.6V50.05H109.8V49.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.999 49.85H109.899V50.05H110.099V49.85H109.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2 49.85H110V50.05H110.2V49.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 49.85H110.3V50.05H110.5V49.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7 49.85H110.5V50.05H110.7V49.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2 50.25V50.05H106V50.15L106.2 50.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.4 50.05H106.2V50.25H106.4V50.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.599 50.05H106.399V50.25H106.599V50.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.9 50.05H106.7V50.25H106.9V50.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9 50.05H108.7V50.25H108.9V50.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 50.05H108.899V50.25H109.099V50.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 50.05H109.1V50.25H109.3V50.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 50.05H109.399V50.25H109.599V50.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 50.05H109.6V50.25H109.8V50.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.999 50.05H109.899V50.25H110.099V50.05H109.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2 50.05H110V50.25H110.2V50.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 50.05H110.3V50.25H110.5V50.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7 50.05H110.5V50.25H110.7V50.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.5 50.45V50.25L105.3 50.35V50.45H105.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.7 50.25H105.5V50.45H105.7V50.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 50.25H105.8V50.45H106V50.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2 50.25H106V50.45H106.2V50.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.4 50.25H106.2V50.45H106.4V50.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.599 50.25H106.399V50.45H106.599V50.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.9 50.25H106.7V50.45H106.9V50.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.899 50.45H106.999C106.999 50.45 106.999 50.35 106.899 50.25V50.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7 50.25C108.7 50.25 108.7 50.35 108.6 50.45H108.7V50.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9 50.25H108.7V50.45H108.9V50.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 50.25H108.899V50.45H109.099V50.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 50.25H109.1V50.45H109.3V50.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 50.25H109.399V50.45H109.599V50.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 50.25H109.6V50.45H109.8V50.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.999 50.25H109.899V50.45H110.099V50.25H109.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2 50.25H110V50.45H110.2V50.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 50.25H110.3V50.45H110.5V50.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 50.25V50.45H110.7C110.7 50.45 110.7 50.35 110.7 50.25H110.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.1 50.45H105V50.55H105.1V50.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.3 50.45H105.1V50.65H105.3V50.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.5 50.45H105.3V50.65H105.5V50.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.7 50.45H105.5V50.65H105.7V50.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 50.45H105.8V50.65H106V50.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2 50.45H106V50.65H106.2V50.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.4 50.45H106.2V50.65H106.4V50.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.599 50.45H106.399V50.65H106.599V50.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.9 50.45H106.7V50.65H106.9V50.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.899 50.65H107.099V50.55H106.899V50.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7 50.65V50.45H108.6C108.6 50.55 108.5 50.55 108.5 50.65H108.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9 50.45H108.7V50.65H108.9V50.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 50.45H108.899V50.65H109.099V50.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 50.45H109.1V50.65H109.3V50.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 50.45H109.399V50.65H109.599V50.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 50.45H109.6V50.65H109.8V50.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.999 50.45H109.899V50.65H110.099V50.45H109.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2 50.45H110V50.65H110.2V50.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 50.45H110.3V50.65H110.5V50.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 50.65H110.6C110.6 50.55 110.6 50.55 110.6 50.45H110.5V50.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.1 50.65H105C105 50.65 105 50.75 105 50.85H105.1V50.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.3 50.65H105.1V50.85H105.3V50.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.5 50.65H105.3V50.85H105.5V50.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.7 50.65H105.5V50.85H105.7V50.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 50.65H105.8V50.85H106V50.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2 50.65H106V50.85H106.2V50.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.4 50.65H106.2V50.85H106.4V50.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.599 50.65H106.399V50.85H106.599V50.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.9 50.65H106.7V50.85H106.9V50.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.099 50.65H106.899V50.85H107.099V50.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.1 50.85H107.3V50.75L107.2 50.65H107.1V50.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.499 50.85L107.399 50.75V50.85H107.499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4 50.85V50.65C108.4 50.65 108.3 50.75 108.2 50.75L108.4 50.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7 50.65H108.5V50.85H108.7V50.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9 50.65H108.7V50.85H108.9V50.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 50.65H108.899V50.85H109.099V50.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 50.65H109.1V50.85H109.3V50.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 50.65H109.399V50.85H109.599V50.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 50.65H109.6V50.85H109.8V50.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.999 50.65H109.899V50.85H110.099V50.65H109.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2 50.65H110V50.85H110.2V50.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 50.65H110.3V50.85H110.5V50.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 50.85C110.6 50.85 110.6 50.75 110.6 50.65H110.5V50.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.3 50.95H105.1V51.05H105.3V50.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.5 50.95H105.3V51.05H105.5V50.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.7 50.95H105.5V51.05H105.7V50.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 50.95H105.8V51.05H106V50.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2 50.95H106V51.05H106.2V50.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.4 50.95H106.2V51.05H106.4V50.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.599 50.95H106.399V51.05H106.599V50.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.9 50.95H106.7V51.05H106.9V50.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.099 50.95H106.899V51.05H107.099V50.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.3 50.95H107.1V51.05H107.3V50.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5 50.95H107.3V51.05H107.5V50.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.6 51.05H107.8V50.85H107.6V51.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 51.05V50.85H107.8V51.05H108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2 50.95H108V51.05H108.2V50.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4 50.95H108.2V51.05H108.4V50.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7 50.95H108.5V51.05H108.7V50.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9 50.95H108.7V51.05H108.9V50.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 50.95H108.899V51.05H109.099V50.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 50.95H109.1V51.05H109.3V50.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 50.95H109.399V51.05H109.599V50.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 50.95H109.6V51.05H109.8V50.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.999 50.95H109.899V51.05H110.099V50.95H109.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2 50.95H110V51.05H110.2V50.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 50.95H110.3V51.05H110.5V50.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.3 51.15H105.1V51.35H105.3V51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.5 51.15H105.3V51.35H105.5V51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.7 51.15H105.5V51.35H105.7V51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 51.15H105.8V51.35H106V51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2 51.15H106V51.35H106.2V51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.4 51.15H106.2V51.35H106.4V51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.599 51.15H106.399V51.35H106.599V51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.9 51.15H106.7V51.35H106.9V51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.099 51.15H106.899V51.35H107.099V51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.3 51.15H107.1V51.35H107.3V51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5 51.15H107.3V51.35H107.5V51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.8 51.15H107.6V51.35H107.8V51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 51.15H107.8V51.35H108V51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2 51.15H108V51.35H108.2V51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4 51.15H108.2V51.35H108.4V51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7 51.15H108.5V51.35H108.7V51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9 51.15H108.7V51.35H108.9V51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 51.15H108.899V51.35H109.099V51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 51.15H109.1V51.35H109.3V51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 51.15H109.399V51.35H109.599V51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 51.15H109.6V51.35H109.8V51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.999 51.15H109.899V51.35H110.099V51.15H109.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2 51.15H110V51.35H110.2V51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.3 51.15V51.35H110.4C110.4 51.35 110.4 51.35 110.4 51.25V51.15H110.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.3 51.35H105.1C105.1 51.35 105.1 51.45 105.2 51.55H105.3V51.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.5 51.35H105.3V51.55H105.5V51.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.7 51.35H105.5V51.55H105.7V51.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 51.35H105.8V51.55H106V51.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2 51.35H106V51.55H106.2V51.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.4 51.35H106.2V51.55H106.4V51.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.599 51.35H106.399V51.55H106.599V51.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.9 51.35H106.7V51.55H106.9V51.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.099 51.35H106.899V51.55H107.099V51.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.3 51.35H107.1V51.55H107.3V51.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5 51.35H107.3V51.55H107.5V51.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.8 51.35H107.6V51.55H107.8V51.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 51.35H107.8V51.55H108V51.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2 51.35H108V51.55H108.2V51.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4 51.35H108.2V51.55H108.4V51.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7 51.35H108.5V51.55H108.7V51.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9 51.35H108.7V51.55H108.9V51.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 51.35H108.899V51.55H109.099V51.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 51.35H109.1V51.55H109.3V51.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 51.35H109.399V51.55H109.599V51.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 51.35H109.6V51.55H109.8V51.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.999 51.35H109.899V51.55H110.099V51.35H109.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2 51.35H110V51.55H110.2V51.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.3 51.55C110.3 51.55 110.4 51.45 110.4 51.35H110.3V51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.2 51.55C105.2 51.55 105.2 51.65 105.3 51.65L105.2 51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.5 51.55H105.3V51.75H105.5V51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.7 51.55H105.5V51.75H105.7V51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 51.55H105.8V51.75H106V51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2 51.55H106V51.75H106.2V51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.4 51.55H106.2V51.75H106.4V51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.599 51.55H106.399V51.75H106.599V51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.9 51.55H106.7V51.75H106.9V51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.099 51.55H106.899V51.75H107.099V51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.3 51.55H107.1V51.75H107.3V51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5 51.55H107.3V51.75H107.5V51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.8 51.55H107.6V51.75H107.8V51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 51.55H107.8V51.75H108V51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2 51.55H108V51.75H108.2V51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4 51.55H108.2V51.75H108.4V51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7 51.55H108.5V51.75H108.7V51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9 51.55H108.7V51.75H108.9V51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 51.55H108.899V51.75H109.099V51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 51.55H109.1V51.75H109.3V51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 51.55H109.399V51.75H109.599V51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 51.55H109.6V51.75H109.8V51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.999 51.55H109.899V51.75H110.099V51.55H109.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.1 51.55V51.75H110.2V51.65L110.1 51.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.5 51.75H105.3C105.3 51.75 105.4 51.85 105.4 51.95L105.5 51.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.7 51.75H105.5V51.95H105.7V51.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 51.75H105.8V51.95H106V51.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2 51.75H106V51.95H106.2V51.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.4 51.75H106.2V51.95H106.4V51.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.599 51.75H106.399V51.95H106.599V51.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.9 51.75H106.7V51.95H106.9V51.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.099 51.75H106.899V51.95H107.099V51.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.3 51.75H107.1V51.95H107.3V51.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5 51.75H107.3V51.95H107.5V51.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.8 51.75H107.6V51.95H107.8V51.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 51.75H107.8V51.95H108V51.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2 51.75H108V51.95H108.2V51.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4 51.75H108.2V51.95H108.4V51.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7 51.75H108.5V51.95H108.7V51.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9 51.75H108.7V51.95H108.9V51.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 51.75H108.899V51.95H109.099V51.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 51.75H109.1V51.95H109.3V51.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 51.75H109.399V51.95H109.599V51.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 51.75H109.6V51.95H109.8V51.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.999 51.75H109.899V51.95H110.099V51.75H109.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.1 51.95L110.2 51.85H110.1V51.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.7 51.95H105.5V52.05L105.6 52.15H105.7V51.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 51.95H105.8V52.15H106V51.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2 51.95H106V52.15H106.2V51.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.4 51.95H106.2V52.15H106.4V51.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.599 51.95H106.399V52.15H106.599V51.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.9 51.95H106.7V52.15H106.9V51.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.099 51.95H106.899V52.15H107.099V51.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.3 51.95H107.1V52.15H107.3V51.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5 51.95H107.3V52.15H107.5V51.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.8 51.95H107.6V52.15H107.8V51.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 51.95H107.8V52.15H108V51.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2 51.95H108V52.15H108.2V51.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4 51.95H108.2V52.15H108.4V51.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7 51.95H108.5V52.15H108.7V51.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9 51.95H108.7V52.15H108.9V51.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 51.95H108.899V52.15H109.099V51.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 51.95H109.1V52.15H109.3V51.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 51.95H109.399V52.15H109.599V51.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 51.95H109.6V52.15H109.8V51.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.899 52.15L110.099 51.95H109.899V52.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 52.25H105.8V52.35L105.9 52.45H106V52.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2 52.25H106V52.45H106.2V52.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.4 52.25H106.2V52.45H106.4V52.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.599 52.25H106.399V52.45H106.599V52.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.9 52.25H106.7V52.45H106.9V52.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.099 52.25H106.899V52.45H107.099V52.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.3 52.25H107.1V52.45H107.3V52.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5 52.25H107.3V52.45H107.5V52.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.8 52.25H107.6V52.45H107.8V52.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 52.25H107.8V52.45H108V52.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2 52.25H108V52.45H108.2V52.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4 52.25H108.2V52.45H108.4V52.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7 52.25H108.5V52.45H108.7V52.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9 52.25H108.7V52.45H108.9V52.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 52.25H108.899V52.45H109.099V52.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3 52.25H109.1V52.45H109.3V52.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 52.25H109.399V52.45H109.599V52.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.6 52.35C109.7 52.35 109.7 52.25 109.8 52.25H109.6V52.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 52.45C106 52.55 106.1 52.55 106.2 52.65V52.45H106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.4 52.45H106.2V52.65H106.4V52.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.599 52.45H106.399V52.65H106.599V52.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.9 52.45H106.7V52.65H106.9V52.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.099 52.45H106.899V52.65H107.099V52.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.3 52.45H107.1V52.65H107.3V52.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5 52.45H107.3V52.65H107.5V52.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.8 52.45H107.6V52.65H107.8V52.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 52.45H107.8V52.65H108V52.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2 52.45H108V52.65H108.2V52.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4 52.45H108.2V52.65H108.4V52.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7 52.45H108.5V52.65H108.7V52.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9 52.45H108.7V52.65H108.9V52.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.099 52.45H108.899V52.65H109.099V52.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.2 52.45V52.65H109.3H109.4V52.55L109.2 52.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.399 52.45C109.399 52.45 109.499 52.45 109.499 52.35L109.399 52.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.3 52.65L106.4 52.75V52.65H106.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.5 52.65C106.5 52.75 106.6 52.75 106.7 52.85V52.75L106.5 52.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.9 52.65H106.7V52.85H106.9V52.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.099 52.65H106.899V52.85H107.099V52.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.3 52.65H107.1V52.85H107.3V52.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5 52.65H107.3V52.85H107.5V52.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.8 52.65H107.6V52.85H107.8V52.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 52.65H107.8V52.85H108V52.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2 52.65H108V52.85H108.2V52.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4 52.65H108.2V52.85H108.4V52.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7 52.65H108.5V52.85H108.7V52.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7 52.65V52.85C108.7 52.85 108.8 52.85 108.9 52.85V52.75L108.7 52.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.1 52.85C107.1 52.85 107.2 52.95 107.3 52.95V52.85H107.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.399 52.85L107.599 52.95V52.85H107.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.6 52.85L107.8 52.95V52.85H107.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.8 52.85L108 52.95V52.85H107.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 52.85C108.1 52.95 108.1 52.95 108.2 52.85H108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.3 20.65L101.5 74.05V22.15C101.5 21.35 102.1 20.75 102.9 20.75L129.3 20.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3997 45.85C95.3997 43.35 104.1 44.25 104.3 47.75C104.4 51.25 92.1997 51.55 94.3997 45.85Z",
    fill: "#F4B298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2996 54.25C93.6996 51.55 101.6 51.05 102.5 54.35C103.4 57.85 92.2996 60.35 93.2996 54.25Z",
    fill: "#F4B298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0997 61.35C95.3997 59.35 102.6 62.75 102.1 65.15C101.5 67.55 91.2997 65.55 94.0997 61.35Z",
    fill: "#F4B298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.9 36.55C133.3 37.35 131.3 47.55 134.9 49.35C138.5 51.15 138.9 34.45 134.9 36.55Z",
    fill: "#F4B298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0998 75.25C91.8998 74.45 91.7998 73.55 91.4998 72.75C91.2998 71.95 90.9998 71.25 90.6998 70.55C89.9998 69.15 88.7998 68.35 87.3998 67.85C86.1998 67.45 84.9998 67.25 83.7998 66.85C83.7998 66.85 83.8998 66.85 83.9998 66.85C85.2998 66.55 86.4998 66.25 87.7998 65.85C89.4998 65.35 90.5998 64.15 91.1998 62.55C91.5998 61.35 91.7998 60.15 92.0998 59.05C92.0998 58.95 92.1998 58.75 92.1998 58.65C92.1998 58.85 92.2998 59.15 92.3998 59.35C92.5998 60.25 92.8998 61.25 93.0998 62.15C93.6998 64.05 94.9998 65.35 96.8998 65.95C97.9998 66.25 99.1998 66.55 100.4 66.85C100.5 66.85 100.5 66.85 100.6 66.95C99.7998 67.15 98.9998 67.25 98.1998 67.45C97.4998 67.65 96.6998 67.85 95.9998 68.15C94.3998 68.85 93.3998 70.15 92.9998 71.75C92.6998 72.75 92.4998 73.75 92.1998 74.75C92.1998 74.95 92.1998 75.15 92.0998 75.25Z",
    fill: "#FAE78D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8997 62.15C91.8997 62.15 90.8997 66.55 87.1997 66.75C87.2997 66.65 91.9997 67.45 91.8997 62.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8999 77.35C94.4999 77.25 95.1999 77.05 95.7999 76.85C97.2999 76.45 98.2999 75.55 98.5999 74.05C98.7999 73.35 98.8999 72.75 99.0999 72.05C99.1999 72.55 99.2999 72.95 99.3999 73.45C99.4999 73.75 99.4999 73.95 99.5999 74.25C99.9999 75.65 101 76.55 102.4 76.85C103.1 77.05 103.7 77.15 104.4 77.35C103.7 77.55 103 77.65 102.3 77.85C101.2 78.15 100.3 78.75 99.8999 79.85C99.6999 80.35 99.4999 80.95 99.3999 81.45C99.2999 81.85 99.1999 82.15 99.0999 82.65C98.9999 82.15 98.8999 81.65 98.7999 81.25C98.6999 80.85 98.5999 80.45 98.4999 80.15C98.0999 79.15 97.3999 78.45 96.3999 78.05C95.4999 77.75 94.6999 77.55 93.8999 77.35Z",
    fill: "#FAE78D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0997 74.45C99.0997 74.45 98.3997 77.25 96.1997 77.35C96.0997 77.25 99.0997 77.85 99.0997 74.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.5 29.15C136.3 28.35 136.2 27.45 135.9 26.65C135.7 25.85 135.4 25.15 135.1 24.45C134.4 23.05 133.2 22.25 131.8 21.75C130.6 21.35 129.4 21.15 128.2 20.75C128.2 20.75 128.3 20.75 128.4 20.75C129.7 20.45 130.9 20.15 132.2 19.75C133.9 19.25 135 18.05 135.6 16.45C136 15.25 136.2 14.05 136.5 12.95C136.5 12.85 136.6 12.65 136.6 12.55C136.6 12.75 136.7 13.05 136.8 13.25C137 14.15 137.3 15.15 137.5 16.05C138.1 17.95 139.4 19.25 141.3 19.85C142.4 20.15 143.6 20.45 144.8 20.75C144.9 20.75 144.9 20.75 145 20.85C144.2 21.05 143.4 21.15 142.6 21.35C141.9 21.55 141.1 21.75 140.4 22.05C138.8 22.75 137.8 24.05 137.4 25.65C137.1 26.65 136.9 27.65 136.6 28.65C136.6 28.85 136.6 29.05 136.5 29.15C136.6 29.15 136.5 29.15 136.5 29.15Z",
    fill: "#FAE78D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.4 16.05C136.4 16.05 135.4 20.45 131.7 20.65C131.7 20.55 136.5 21.35 136.4 16.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.7 31.55C124.3 31.45 125 31.25 125.6 31.05C127.1 30.65 128.1 29.75 128.4 28.25C128.6 27.55 128.7 26.95 128.9 26.25C129 26.75 129.1 27.15 129.2 27.65C129.3 27.95 129.3 28.15 129.4 28.45C129.8 29.85 130.8 30.75 132.2 31.05C132.9 31.25 133.5 31.35 134.2 31.55C133.5 31.75 132.8 31.85 132.1 32.05C131 32.35 130.1 32.95 129.7 34.05C129.5 34.55 129.3 35.15 129.2 35.65C129.1 36.05 129 36.35 128.9 36.85C128.8 36.35 128.7 35.85 128.6 35.45C128.5 35.05 128.4 34.65 128.3 34.35C127.9 33.35 127.2 32.65 126.2 32.25C125.3 31.95 124.5 31.75 123.7 31.55Z",
    fill: "#FAE78D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.9 28.55C128.9 28.55 128.2 31.35 126 31.45C125.9 31.45 128.9 31.95 128.9 28.55Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenApp);
export default __webpack_public_path__ + "static/media/open-app.d6568665f4d94bae05dc0b099f835712.svg";
export { ForwardRef as ReactComponent };